interface NotificationNameCellProps {
  firstName: string
  lastName: string
}
function NotificationNameCell({ firstName, lastName }: NotificationNameCellProps) {
  return (
    <>
      {firstName && (
        <span
          className="d-inline-block mr-2"
          style={{ maxWidth: "250px", overflow: "hidden", textOverflow: "ellipsis" }}
        >
          {firstName}
        </span>
      )}
      {firstName && (
        <span className="d-inline-block" style={{ maxWidth: "250px", overflow: "hidden", textOverflow: "ellipsis" }}>
          {lastName}
        </span>
      )}
    </>
  )
}

export default NotificationNameCell
